import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/phone2.png';
import _imports_1 from '../assets/phone3.png';
const _hoisted_1 = {
  class: "main-layout"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "imag-layout"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: "phone2",
  src: _imports_0,
  class: "image-one"
}), /*#__PURE__*/_createElementVNode("img", {
  alt: "phone3",
  src: _imports_1,
  class: "image-two"
})], -1);
const _hoisted_3 = {
  class: "show-layout"
};
const _hoisted_4 = {
  class: "item"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, " 创建编辑二维码条码 ", -1);
const _hoisted_6 = {
  class: "item"
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, " 识别二维码条码 ", -1);
const _hoisted_8 = {
  class: "item"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, " 打印二维码条码 ", -1);
const _hoisted_10 = {
  class: "item"
};
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, " 支持图文二维码 ", -1);
const _hoisted_12 = {
  class: "item"
};
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, " 支持Android和iOS ", -1);
import { Camera, Printer, Edit, Document, Cpu } from "@element-plus/icons-vue";
export default {
  __name: 'MidComponents',
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_icon, {
        size: "20",
        color: "#fff"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Edit))]),
        _: 1
      }), _hoisted_5]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_icon, {
        size: "20",
        color: "#fff"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Camera))]),
        _: 1
      }), _hoisted_7]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_icon, {
        size: "20",
        color: "#fff"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Printer))]),
        _: 1
      }), _hoisted_9]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_icon, {
        size: "20",
        color: "#fff"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Document))]),
        _: 1
      }), _hoisted_11]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_icon, {
        size: "20",
        color: "#fff"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Cpu))]),
        _: 1
      }), _hoisted_13])])]);
    };
  }
};